import axios, { getData } from "lib/axios";

export const login = async (data) => {
  return axios.post("/login", data, { skipAuthSessionHandling: true });
};

export const logout = async () => {
  return axios.get('/sign-out', { skipAuthSessionHandling: true })
};

export const getSession = async () => {
  return axios.get('/session').then(getData)
}

export const extendSession = async () => {
  return axios
    .post('/session/extend', undefined, { skipAuthSessionHandling: true })
    .then(getData)
}

export const myAccount = async () => {
  return axios.get("/my-account").then(getData);
};

export const changePassword = async (data) => {
  return axios.post("/change-password", data).then(getData);
};

export const onboardingJobInformation = async () => {
  return axios.get("/job-information").then(getData);
};

export const onboardingContactDetails = async (data) => {
  return axios.post("/contact-details", data).then(getData);
};
